"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const d3 = __importStar(require("d3"));
const lodash_1 = __importDefault(require("lodash"));
const canvas_1 = require("canvas");
const resize_observer_polyfill_1 = __importDefault(require("resize-observer-polyfill"));
const d3_interpolate_path_1 = require("d3-interpolate-path");
const chartStyles_1 = __importDefault(require("./chartStyles"));
const connectedAxis_1 = require("./connectedAxis");
const constants_1 = require("./constants");
const delaunay_1 = require("./delaunay");
const drawCanvas_1 = __importDefault(require("./drawCanvas"));
const helpers_1 = require("./helpers");
const error_1 = require("../error");
const InfoTooltip_1 = __importDefault(require("../InfoTooltip"));
const SourcesAndFootnotes_1 = __importDefault(require("../SourcesAndFootnotes"));
const Tooltip_1 = __importDefault(require("../Tooltip"));
const constants_2 = require("../../constants");
const chart_helpers_1 = require("../../util/chart.helpers");
const Triggerable_1 = __importDefault(require("../../util/Triggerable"));
require("./LineChart.scss");
const common_module_scss_1 = __importDefault(require("../../styles/common.module.scss"));
const LABEL_ANNOTATION_PADDING = 24;
const DEFAULT_HEIGHT = 500;
const INTRO_LENGTH = 3000;
const TRANSITION_LENGTH = 1000;
const AUTO_LEGEND_BREAKPOINT = 768;
const AXIS_MONTH_LONG_BREAKPOINT = 400;
const DEFAULT_HOVER_OPACITIES = 'lineHoverOpacities';
function measureYAxis(drawParams, ticks, fontSize) {
  const context = (0, canvas_1.createCanvas)(300, 300).getContext('2d');
  context.font = `${fontSize}px ${common_module_scss_1.default.mainFontFamily}`;
  const format = (0, chart_helpers_1.valueFormat)(drawParams);
  return lodash_1.default.max(ticks.map(tick => context.measureText(format(tick, {
    ticks
  })).width));
}
function checkActivePoint(chart, d) {
  var _active$key;
  const active = chart.tooltipDatum;
  return !chart.dragging && active && d && d.dataset === active.dataset && d.key.getTime() === ((_active$key = active.key) === null || _active$key === void 0 ? void 0 : _active$key.getTime());
}
function tooltipListener(drawParams, x, y) {
  const {
    params: {
      tooltipOptions: {
        tooltipStyle = 'bubble',
        hoverStyle = null
      }
    }
  } = drawParams;
  const hoverDatum = this.getHoverDatum(drawParams, this.delaunays, x, y, hoverStyle);
  const circles = this.svg.selectAll(`circle.${this.cssPrefix}-circle`);
  if (hoverDatum) {
    const {
      datum,
      xDiff,
      yDiff
    } = hoverDatum;
    const selector = d => d.dataset === datum.dataset && d.key.getTime() === datum.key.getTime();
    if (this.tooltip) {
      if (tooltipStyle === 'scrub') {
        this.showScrub(x, circles, selector);
      } else {
        this.tooltipDatum = this.showTooltip(drawParams, datum, circles, selector, {
          xDiff,
          yDiff
        });
      }
    }
    this.trigger('point', datum);
  } else {
    this.showLastPoint(drawParams);
    this.hideTooltip();
    this.svg.select(`.${this.cssPrefix}-scrub`).style('opacity', 0);
    this.trigger('point', null);
  }
}
function lineListener(drawParams, x, y) {
  const {
    params,
    params: {
      tooltipOptions: {
        hoverStyle = null
      }
    }
  } = drawParams;
  const hoverDatum = this.getHoverDatum(drawParams, this.lineDelaunays, x, y, hoverStyle);
  if (!hoverDatum) {
    this.showLastPoint(drawParams);
    this.hideTooltip();
    return;
  }
  const {
    datum
  } = hoverDatum;
  const hovered = this.dataSelector(datum.metric, params);
  let didHover = false;
  this.group.select(`.${this.cssPrefix}-chart`).selectAll(`path.${this.cssPrefix}-line`).each(d => {
    let lineHovered = false;
    if (datum.metric.selector) {
      lineHovered = d.selector === datum.metric.selector;
    } else {
      lineHovered = d.id === datum.metric.id && this.dataSelector(d, params) === hovered;
    }
    if (lineHovered) {
      didHover = true;
      this.setLineOpacity(drawParams, null, hovered);
      this.setLegendOpacity(drawParams, null, hovered);
      this.onlyDrawLabels(drawParams, null, hovered);
      this.trigger('hover', d);
    }
  });
  if (!didHover) {
    this.setLineOpacity(drawParams);
    this.setLegendOpacity(drawParams);
    this.onlyDrawLabels(drawParams);
    this.trigger('hover', null);
  }
}
function clickListener(drawParams, x, y) {
  const {
    params
  } = drawParams;
  const hoverDatum = this.getHoverDatum(drawParams, this.lineDelaunays, x, y);
  if (!hoverDatum) {
    this.highlighted = [];
    this.trigger('click', null);
  } else {
    const {
      datum
    } = hoverDatum;
    const selector = this.dataSelector(datum.metric, params);
    if (selector === this.highlighted[0]) {
      this.highlighted = [];
      this.trigger('click', null);
    } else {
      this.highlighted = [selector];
      this.trigger('click', datum.metric);
    }
  }
  this.drawContent(drawParams);
}
class LineChart extends Triggerable_1.default {
  constructor(container, isSubchart, width, height, cssPrefix) {
    super();
    this.chartType = constants_2.CHART_TYPES.LineChart;
    this.container = container;
    this.cssPrefix = cssPrefix || 'line-chart';
    this.yTicks = 4;
    this.xTicks = 8;
    this.width = width || 1000;
    this.height = height || DEFAULT_HEIGHT;
    this.circleR = 5;
    this.maxHoverDistance = 200;
    this.delaunays = null;
    this.isSubchart = isSubchart;
    // touch event variables
    this.preventMouseMove = false;
    this.touchTimer = null;
    this.firstTouch = null;
    this.preventDefault = null;
    this.dragging = false;
    this.tooltipDatum = null;
    this.highlighted = [];
    if (this.container === undefined) {
      this.draw = this.drawCanvas;
      return;
    }
    this.title = container.append('div').classed('chart-title', true);
    this.subtitle = container.append('div').classed('chart-subtitle', true);
    this.legend = container.append('div').classed('chart-legend', true);
    this.svg = container.classed(this.cssPrefix, true).classed('dh-chart-wrapper', true).append('svg').classed(this.cssPrefix, true).attr('viewBox', `0 0 ${this.width} ${this.height}`);
    this.defs = this.svg.append('defs');
    this.group = this.svg.append('g').classed(`${this.cssPrefix}-all`, true);
    this.sourceContainer = this.container.append('div');
    this.sources = new SourcesAndFootnotes_1.default(this.sourceContainer);
    this.tooltip = new Tooltip_1.default(container);
    this.initGroups();
    this.ro = new resize_observer_polyfill_1.default(entries => {
      entries.forEach(entry => {
        const {
          width: containerWidth
        } = entry.contentRect;
        if (containerWidth !== this.width) {
          requestAnimationFrame(() => {
            this.resizeContent(containerWidth);
          });
        }
      });
    });
    this.ro.observe(container.node());
  }
  async initGroups() {
    this.group.append('g').classed('axis', true).classed('y', true);
    this.group.append('g').attr('class', 'axis y-labels');
    this.group.append('g').classed('axis', true).classed('x', true);
    this.group.append('g').classed(`${this.cssPrefix}-chart`, true);
    this.group.append('path').classed(`${this.cssPrefix}-delaunay`, true);
    const overlay = this.group.append('g').classed(`${this.cssPrefix}-overlay`, true).on('mouseleave', () => {
      this.preventDefault = null;
      this.firstTouch = null;
      this.showLastPoint(this.cachedParams);
      this.hideTooltip();
      this.svg.select(`.${this.cssPrefix}-scrub`).style('opacity', 0);
      this.trigger('point', null);
      this.dragging = false;
    }, {
      passive: true
    }).on('touchend', () => {
      this.preventDefault = null;
      this.firstTouch = null;
      if (this.dragging) {
        this.setLineOpacity(this.cachedParams);
        this.setLegendOpacity(this.cachedParams);
        this.onlyDrawLabels(this.cachedParams);
        this.showLastPoint(this.cachedParams);
        this.hideTooltip();
      }
      this.svg.select(`.${this.cssPrefix}-scrub`).style('opacity', 0);
      this.dragging = false;
    }, {
      passive: true
    });
    overlay.append('line').classed(`${this.cssPrefix}-scrub`, true).style('opacity', 0).classed('bold', true);
    overlay.append('rect').classed(`${this.cssPrefix}-mouse`, true);
    this.legend.append('div').classed('legend-title', true);
    this.legend.append('div').classed('legend-items', true);
    error_1.initError.call(this);
  }
  async data(promises, options) {
    const fetched = await error_1.tryChartPromises.call(this, promises);
    if (!fetched) return null;
    const {
      data,
      parent
    } = fetched;
    const startDate = options.startDate || options.startYear;
    const endDate = options.endDate || options.endYear;
    const filtered = data.filter(d => d.metric.data && d.metric.data.length > 0).map((d, i) => {
      const f = d.metric.data.filter(_ref => {
        let {
          key,
          value
        } = _ref;
        if (value === null || value === undefined) {
          return false;
        }
        if (startDate && key < (0, chart_helpers_1.dateParser)(startDate, d.metric.xType)) {
          return false;
        }
        if (endDate && key > (0, chart_helpers_1.dateParser)(endDate, d.metric.xType)) {
          return false;
        }
        return true;
      });
      return {
        ...d,
        metric: {
          ...d.metric,
          data: f
        },
        sortIndex: i
      };
    });
    return {
      data: filtered,
      parent
    };
  }
  colourFunction(d, i, params) {
    return LineChart.getChartStyleParam(params, 'colourFunction')(this, d, i, params);
  }
  dataSelector(d, params) {
    return LineChart.getChartStyleParam(params, 'dataSelector').call(this, d);
  }
  static getChartStyleParam(params, param) {
    return params.chartStyle[param] ?? chartStyles_1.default.default[param];
  }
  createYScale(_ref2) {
    let {
      data,
      params
    } = _ref2;
    const {
      yDomain,
      yValues,
      margins
    } = params;
    if (yValues) {
      const domain = [yValues[0], yValues.slice(-1)[0]];
      return d3.scaleLinear().domain(domain).range([this.height - margins.bottom, margins.top]);
    }
    const values = lodash_1.default.flatMap(data, d => d.metric.data.map(_ref3 => {
      let {
        value
      } = _ref3;
      return Number(value);
    }));
    let dataYDomain = [lodash_1.default.min(values), lodash_1.default.max(values)];
    if (dataYDomain[0] >= 0 && dataYDomain[1] >= 0) {
      const diff = dataYDomain[1] - dataYDomain[0];
      if (dataYDomain[0] - diff <= 0) {
        dataYDomain = [0, dataYDomain[1]];
      }
    } else if (dataYDomain[0] <= 0 && dataYDomain[1] <= 0) {
      const diff = dataYDomain[0] - dataYDomain[1];
      if (dataYDomain[1] + diff >= 0) {
        dataYDomain = [dataYDomain[0], 0];
      }
    }
    if (this.height > 300) {
      this.yTicks = 4;
    } else {
      this.yTicks = 3;
    }
    return d3.scaleLinear().domain(yDomain || dataYDomain).range([this.height - margins.bottom, margins.top]).nice(this.yTicks);
  }
  maxYAxisOffset() {
    return Math.min(80, this.width * 0.12);
  }
  yAxisOffset(drawParams, yScale) {
    const {
      params: {
        fontSize,
        hideAxisLabels,
        margins,
        yValueLabels
      }
    } = drawParams;
    const measuredAxisWidth = yValueLabels ? (0, connectedAxis_1.measureYLabels)(yValueLabels, this.maxYAxisOffset(), fontSize) : measureYAxis(drawParams, yScale.ticks(this.yTicks), fontSize);
    const yAxisWidth = margins.fixedAxis === undefined ? measuredAxisWidth : parseFloat(margins.fixedAxis);
    return hideAxisLabels === true || hideAxisLabels === 'y' ? 0 : yAxisWidth;
  }
  createXScale(drawParams, yScale, labelWidth) {
    const {
      data,
      params
    } = drawParams;
    const {
      xDomain,
      margins
    } = params;
    const rightLabelWidth = Math.max(labelWidth, margins.minRightLabel);
    const rightRange = this.width - margins.right - rightLabelWidth - constants_1.LABEL_PADDING;
    const dates = lodash_1.default.flatMap(data, d => lodash_1.default.map(d.metric.data, 'key'));
    const dataXDomain = [lodash_1.default.min(dates), lodash_1.default.max(dates)];
    return d3.scaleUtc().domain(xDomain || dataXDomain).range([margins.left + this.yAxisOffset(drawParams, yScale) + margins.xAxis, rightRange]);
  }
  createScales(drawParams, labelWidth) {
    const yScale = this.createYScale(drawParams);
    const xScale = this.createXScale(drawParams, yScale, labelWidth);
    return {
      xScale,
      yScale
    };
  }
  strokeWidth(d, params) {
    return LineChart.getChartStyleParam(params, 'strokeWidth')(d, params, this.isSubchart);
  }
  getLabel(d, isSubchart, mode, _ref4) {
    let {
      hideLineLabels,
      useStateAbbreviations
    } = _ref4;
    if (hideLineLabels) {
      return '';
    }
    const nonAbbrevLabel = (0, helpers_1.getNonAbbrevLabel)(d, isSubchart, mode);
    if (useStateAbbreviations || this.width < 650) {
      return (0, chart_helpers_1.getStateAbbreviation)(nonAbbrevLabel);
    }
    return nonAbbrevLabel;
  }
  async draw(promises) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const allData = await this.data(promises, options);
    if (!allData) {
      this.trigger('dataLoaded', false);
      return false;
    }
    const {
      data,
      parent
    } = allData;
    const optionParams = (0, helpers_1.getDrawParams)({
      data,
      parent,
      options
    });
    const drawParams = {
      data,
      parent,
      params: optionParams
    };
    this.drawContent(drawParams);
    this.trigger('finishDraw');
    this.trigger('dataLoaded', true);
    return true;
  }
  redrawContent() {
    if (this.cachedParams) {
      this.drawContent(this.cachedParams);
    }
  }
  resizeContent(newWidth) {
    if (this.cachedParams && this.width !== newWidth) {
      this.drawContent(this.cachedParams, false);
    }
  }
  handleMouseEvent(drawParams, event, listeners) {
    const {
      data,
      ...p
    } = drawParams;
    this.touchTimer = null;
    let {
      clientX,
      clientY
    } = event;
    if (event.touches) {
      clientX = event.touches[0].clientX;
      clientY = event.touches[0].clientY;
    }
    const overlay = this.svg.select(`.${this.cssPrefix}-mouse`);
    const box = overlay.node().getBoundingClientRect();
    if (clientX < box.left) clientX = box.left;
    if (clientX > box.right) clientX = box.right;
    const {
      top,
      left
    } = event.target.ownerSVGElement.getBoundingClientRect();
    const hoverDatum = this.getHoverDatum(drawParams, this.delaunays, clientX - left, clientY - top);
    let clickedActivePoint = false;
    if (event.type === 'click') {
      if (hoverDatum && checkActivePoint(this, hoverDatum.datum)) {
        this.hideTooltip();
        clickedActivePoint = true;
      }
      clickListener.call(this, drawParams, clientX - left, clientY - top);
    }
    const tooltipFilteredData = data.filter(d => this.isHighlighted(d, p.params));
    if (!clickedActivePoint && (event.type !== 'click' || p.params.tooltipOnTap)) {
      tooltipListener.call(this, {
        data: tooltipFilteredData,
        ...p
      }, clientX - left, clientY - top);
    }
    if (event.type !== 'click') {
      lineListener.call(this, drawParams, clientX - left, clientY - top);
    }
    listeners.forEach(l => {
      l(drawParams, clientX - left, clientY - top);
    });
  }
  setPreventDefault(event) {
    if (this.preventDefault !== null) return this.preventDefault;
    if (this.firstTouch !== null) {
      const touch = event.touches[0];
      if (Math.abs(touch.pageX - this.firstTouch.pageX) > Math.abs(touch.pageY - this.firstTouch.pageY)) {
        this.preventDefault = true;
        return true;
      }
      this.preventDefault = false;
      return false;
    }
    return null;
  }
  setHoverListener(drawParams) {
    for (var _len = arguments.length, listeners = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      listeners[_key - 1] = arguments[_key];
    }
    this.group.select(`.${this.cssPrefix}-mouse`).on('contextmenu', event => {
      event.preventDefault();
    }, {
      passive: true
    }).on('touchstart', event => {
      // prevent mousemove on touchmove
      this.preventMouseMove = true;
      const {
        touches
      } = event;
      this.firstTouch = touches.length ? touches[0] : null;
      if (!this.touchTimer) {
        this.touchTimer = setTimeout(() => {
          this.handleMouseEvent(drawParams, event, listeners);
        }, 500);
      }
    }, {
      passive: true
    }).on('mousemove touchmove', lodash_1.default.throttle(event => {
      // clear mousemove preventer
      if (this.preventMouseMove) {
        this.preventMouseMove = false;
      } else if (event.type !== 'touchmove') {
        this.handleMouseEvent(drawParams, event, listeners);
      } else if (this.setPreventDefault(event)) {
        this.dragging = true;
        event.preventDefault();
        event.stopPropagation();
        this.handleMouseEvent(drawParams, event, listeners);
      }
      clearTimeout(this.touchTimer);
      this.touchTimer = null;
      return false;
    }, constants_2.THROTTLE, {
      trailing: false
    }), {
      passive: false
    });
  }
  setClickListener(drawParams) {
    for (var _len2 = arguments.length, listeners = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      listeners[_key2 - 1] = arguments[_key2];
    }
    this.group.select(`.${this.cssPrefix}-mouse`).on('click', event => {
      this.handleMouseEvent(drawParams, event, listeners);
    });
  }
  setHovered(hovered) {
    if (this.cachedParams) {
      this.setLineOpacity(this.cachedParams, 'externalHoverOpacities', hovered);
      this.onlyDrawLabels(this.cachedParams, 'externalHoverOpacities', hovered);
      this.setLegendOpacity(this.cachedParams, 'externalHoverOpacities', hovered);
    }
  }
  onlyDrawLabels(_ref5, overrideOpacityParam, hovered) {
    let {
      data,
      params
    } = _ref5;
    const showLabels = !this.showLegend(params) && (!this.isSubchart || data.length > 1);
    const defaultLabelWidth = Math.min(150, this.width * 0.4);
    const maxLabelWidth = params.margins.maxRightLabel === undefined ? defaultLabelWidth : params.margins.maxRightLabel;
    const labelMode = (0, chart_helpers_1.getLabelTextMode)(data, params);
    const labels = data.map(d => this.getLabel(d, this.isSubchart, labelMode, params));
    const labelSize = (0, helpers_1.getLabelSizing)(labels, maxLabelWidth, params.fontSize);
    this.drawLabels({
      data,
      params
    }, this.yScale, this.xScale.range()[1] + constants_1.LABEL_PADDING, maxLabelWidth, labelSize, showLabels, hovered, false, overrideOpacityParam);
  }
  showLegend(params) {
    return params.showLegend === true || params.showLegend === null && this.width <= AUTO_LEGEND_BREAKPOINT;
  }
  drawContent(drawParams) {
    let overrideTransition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    this.cachedParams = drawParams;
    const {
      data,
      params
    } = drawParams;
    const shouldTransition = overrideTransition ?? params.transition;
    const {
      titleVerticalPosition,
      hideTitle,
      showSourcesAndFootnotes,
      heightToWidthRatio,
      margins,
      fontSize,
      yValueExtraLabels,
      startDate,
      endDate,
      areaFill,
      annotateEnd,
      info,
      hideTooltip
    } = params;
    this.width = this.container.node().getBoundingClientRect().width;
    if (this.highlightedData(drawParams).length === 0) {
      this.highlighted = [];
    }
    if (titleVerticalPosition === 'top') {
      this.title.classed('below', false);
      this.container.node().insertBefore(this.title.node(), this.svg.node());
      this.container.node().insertBefore(this.subtitle.node(), this.svg.node());
      this.container.node().insertBefore(this.legend.node(), this.svg.node());
    } else if (titleVerticalPosition === 'bottom') {
      this.title.classed('below', true);
      this.container.node().insertBefore(this.legend.node(), this.svg.node());
      this.container.node().append(this.title.node());
      this.container.node().append(this.subtitle.node());
      this.container.node().append(this.sourceContainer.node());
    }
    if (!hideTitle) {
      chart_helpers_1.drawTitle.call(this, this.title, this.subtitle, drawParams);
    }
    this.drawLegend(drawParams, this.showLegend(params));
    if (showSourcesAndFootnotes) {
      this.sources.draw(data, params);
    }
    if (heightToWidthRatio) {
      this.height = heightToWidthRatio * this.width;
    } else {
      const {
        height: titleHeight
      } = this.title.node().getBoundingClientRect();
      const {
        height: subtitleHeight
      } = this.subtitle.node().getBoundingClientRect();
      const {
        height: legendHeight
      } = this.legend.node().getBoundingClientRect();
      const {
        height: sourcesHeight
      } = this.sourceContainer.node().getBoundingClientRect();
      const {
        height: wrapperHeight
      } = this.container.node().getBoundingClientRect();
      this.height = wrapperHeight - titleHeight - subtitleHeight - legendHeight - sourcesHeight;
    }
    d3.select(this.svg.node()).attr('viewBox', `0 0 ${this.width} ${this.height}`);
    const showLabels = !this.showLegend(params) && (!this.isSubchart || data.length > 1);
    const defaultLabelWidth = Math.min(150, this.width * 0.4);
    const maxLabelWidth = margins.maxRightLabel === undefined ? defaultLabelWidth : margins.maxRightLabel;
    const labelMode = (0, chart_helpers_1.getLabelTextMode)(data, params);
    const labels = data.map(d => this.getLabel(d, this.isSubchart, labelMode, params));
    const labelSize = (0, helpers_1.getLabelSizing)(labels, maxLabelWidth, fontSize);
    const {
      xScale,
      yScale
    } = this.createScales({
      data,
      params
    }, showLabels ? labelSize.width : 0);
    this.xScale = xScale;
    this.yScale = yScale;
    const extraLabelOffset = yValueExtraLabels ? `${this.yAxisOffset({
      data,
      params
    }, this.yScale) + margins.xAxis}px` : null;
    this.title.style('margin-left', extraLabelOffset);
    this.legend.style('margin-left', extraLabelOffset);
    const dataSelector = LineChart.getChartStyleParam(params, 'dataSelector');
    this.allDataPoints = (0, chart_helpers_1.allDataPoints)(data, startDate, endDate, data[0] ? data[0].metric.xType : 'years', dataSelector);
    this.group.select(`.${this.cssPrefix}-mouse`).attr('x', xScale.range()[0] - constants_1.LABEL_PADDING).attr('y', yScale.range()[1] - constants_1.LABEL_PADDING);
    this.setHoverListener(drawParams);
    this.group.select(`.${this.cssPrefix}-mouse`).on('mouseleave', () => {
      this.trigger('hover', null);
      this.setLineOpacity(drawParams);
      this.onlyDrawLabels(drawParams);
      this.setLegendOpacity(drawParams);
    });
    this.setClickListener(drawParams);
    this.delaunays = (0, delaunay_1.getDelaunays)(drawParams, xScale, yScale, d => this.isHighlighted(d, params), dataSelector);
    this.lineDelaunays = (0, delaunay_1.getDelaunays)(drawParams, xScale, yScale, dataSelector);
    const chartAreaWidth = Math.max(0, xScale.range()[1] - xScale.range()[0]);
    const chartAreaHeight = Math.max(0, yScale.range()[0] - yScale.range()[1]);
    this.svg.select(`.${this.cssPrefix}-mouse`).attr('width', chartAreaWidth > 0 ? chartAreaWidth + constants_1.LABEL_PADDING * 2 : 0).attr('height', chartAreaHeight > 0 ? chartAreaHeight + constants_1.LABEL_PADDING * 2 : 0);
    this.svg.select(`.${this.cssPrefix}-scrub`).attr('y1', yScale.range()[0]).attr('y2', yScale.range()[1]);
    const shouldAreaFill = areaFill && data.length === 1;
    const defsID = this.newDefsID(data);
    const gradientID = `${this.cssPrefix}-area-gradient-${defsID}`;
    const maskID = `${this.cssPrefix}-mask-wipein-${defsID}`;
    this.drawArea(drawParams, shouldAreaFill, gradientID);
    const labelPadding = annotateEnd ? LABEL_ANNOTATION_PADDING : constants_1.LABEL_PADDING;
    this.drawLabels(drawParams, yScale, xScale.range()[1] + labelPadding, maxLabelWidth, labelSize, showLabels, null, shouldTransition);
    this.drawLines(drawParams, xScale, yScale, shouldAreaFill, maskID, shouldTransition);
    // Annotate the end points of each line
    if (annotateEnd) {
      this.drawEndAnnotations(drawParams, xScale, yScale);
    }
    this.drawAxes(drawParams, xScale, yScale);
    if (info && info.position === 'chart' && !this.isSubchart) {
      InfoTooltip_1.default.inChart(this.container, params);
    }
    if (hideTooltip) {
      this.tooltip = null;
    }
  }
  newDefsID(data) {
    let idCount = 0;
    const prefix = `${this.cssPrefix}-area-gradient`;
    let suffix = `${data.map(d => d.metric.id).join('-')}-${idCount}`;
    let gradientID = `${prefix}-${suffix}`;
    let gradientExistsSelection = d3.select(`#${gradientID}`);
    while (!gradientExistsSelection.empty() && idCount < 1000) {
      idCount += 1;
      suffix = `${suffix.split('-').slice(0, -1).join('-')}-${idCount}`;
      gradientID = `${prefix}-${suffix}`;
      gradientExistsSelection = d3.select(`#${gradientID}`);
    }
    return suffix;
  }
  drawArea(_ref6, shouldAreaFill, gradientID) {
    let {
      data,
      params
    } = _ref6;
    const area = d3.area().x(d => this.xScale(d.key)).y0(this.yScale.range()[0]).y1(d => this.yScale(d.value));
    const chartAreaGroup = this.svg.select(`g.${this.cssPrefix}-chart`);
    let gradient = this.defs.select('linearGradient');
    let areaPath = chartAreaGroup.select(`path.${this.cssPrefix}-area`);
    if (areaPath.empty()) {
      gradient = this.defs.append('linearGradient').attr('gradientUnits', 'userSpaceOnUse').attr('x1', 0).attr('x2', 0).attr('y1', 0).attr('y2', this.yScale.range()[0]);
      gradient.append('stop').classed('gradient-primary', true).attr('offset', 0);
      gradient.append('stop').attr('offset', '100%').attr('stop-color', 'rgb(247,250,253)');
      areaPath = chartAreaGroup.append('path').classed(`${this.cssPrefix}-area`, true);
    }
    gradient.attr('y2', this.yScale.range()[0]);
    gradient.select('.gradient-primary').attr('stop-color', this.colourFunction(data[0], 0, params));
    gradient.attr('id', gradientID);
    areaPath.datum(data[0].metric.data).attr('d', d => area(d)).attr('fill', shouldAreaFill ? `url(#${gradientID})` : 'rgba(255,255,255,0)');
  }
  drawLabels(_ref7, yScale, x, width, _ref8, showLabels) {
    let {
      data,
      params
    } = _ref7;
    let {
      fontSize,
      fontWeight
    } = _ref8;
    let hovered = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
    let transition = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
    let opacityParam = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : DEFAULT_HOVER_OPACITIES;
    const showInactiveLabels = LineChart.getChartStyleParam(params, 'showInactiveLabels');
    const highlighted = showInactiveLabels ? data : this.highlightedLabels({
      data,
      params
    }, hovered);
    const chartAreaGroup = this.svg.select(`g.${this.cssPrefix}-chart`);
    const labelMode = (0, chart_helpers_1.getLabelTextMode)(data, params);
    let labels = [];
    if (showLabels) {
      labels = highlighted.map(label => {
        const labelText = this.getLabel(label, this.isSubchart, labelMode, params);
        const hasCustomLabel = label.labelText !== undefined;
        const lastPoint = label.metric.data.slice(-1)[0];
        return {
          text: (0, chart_helpers_1.breakLines)(labelText, width, `${fontWeight} ${fontSize}px ${common_module_scss_1.default.mainFontFamily}`, hasCustomLabel ? Infinity : 2),
          y: yScale(lastPoint ? lastPoint.value : 0),
          dataset: this.dataSelector(label, params),
          ...label
        };
      });
    }
    const firstDraw = this.defs.select('mask').empty();
    const labelElements = chartAreaGroup.selectAll(`text.${this.cssPrefix}-label`).data((0, helpers_1.forceLabels)(labels, {
      maxY: yScale.range()[0],
      fontSize,
      labelLineHeight: constants_1.LABEL_LINE_HEIGHT
    }), d => this.dataSelector(d, params)).join(enter => {
      const text = enter.append('text').style('fill', (d, i) => this.colourFunction(d, d.sortIndex || i, params)).attr('x', x).attr('y', d => d.y);
      if (transition && !firstDraw) {
        text.style('opacity', 0);
      }
      return text;
    }, update => update).classed(`${this.cssPrefix}-label`, true);
    labelElements.on('mousemove', lodash_1.default.throttle((event, label) => this.onLabelHover(this.cachedParams, label), constants_2.THROTTLE, {
      trailing: false
    }), {
      passive: true
    }).on('mouseout', () => {
      if (!this.preventMouseMove) {
        this.showLastPoint(this.cachedParams);
        this.hideTooltip();
      }
      this.setLineOpacity({
        data,
        params
      }, opacityParam);
      this.setLabelOpacity({
        data,
        params
      }, opacityParam);
      this.setLegendOpacity({
        data,
        params
      }, opacityParam);
      this.dragging = false;
    }, {
      passive: true
    }).on('click', (event, label) => {
      this.onLabelClick(this.cachedParams, label);
    }, {
      passive: true
    }).style('font-size', `${fontSize}px`).style('font-weight', fontWeight).style('display', this.isSubchart && data.length === 1 ? 'none' : null);
    const labelSpans = labelElements.selectAll('tspan').data(d => d.text).join(enter => enter.append('tspan').attr('x', x), update => update, exit => {
      if (transition) {
        exit.call(e => e.transition().duration(TRANSITION_LENGTH).style('opacity', 0).on('end', () => e.remove()));
      } else {
        exit.remove();
      }
    }).text(d => d);
    if (transition) {
      labelElements.transition('labelMove').duration(TRANSITION_LENGTH).style('fill', (d, i) => this.colourFunction(d, d.sortIndex || i, params)).attr('y', d => d.y);
      labelSpans.transition('spanMove').duration(TRANSITION_LENGTH).attr('dy', (d, i) => i ? `${constants_1.LABEL_LINE_HEIGHT}em` : null).attr('x', x);
    } else {
      labelElements.style('fill', (d, i) => this.colourFunction(d, d.sortIndex || i, params)).attr('y', d => d.y);
      labelSpans.attr('dy', (d, i) => i ? `${constants_1.LABEL_LINE_HEIGHT}em` : null).attr('x', x);
    }
    const selection = chartAreaGroup.selectAll(`text.${this.cssPrefix}-label`);
    if (firstDraw) {
      if (params.intro) {
        selection.style('opacity', 0);
      } else if (transition) {
        selection.style('opacity', d => this.getLabelOpacity(d, {
          data,
          params
        }, null, opacityParam));
      }
      selection.attr('x', x).attr('y', d => d.y);
    } else if (params.intro && chartAreaGroup.attr('mask')) {
      selection.style('opacity', 0).attr('x', x).attr('y', d => d.y);
    } else if (transition) {
      selection.transition('fadeIn').duration(TRANSITION_LENGTH).style('opacity', d => this.getLabelOpacity(d, {
        data,
        params
      }, null, opacityParam)).attr('x', x).attr('y', d => d.y);
    } else {
      selection.style('opacity', d => this.getLabelOpacity(d, {
        data,
        params
      }, null, opacityParam)).attr('x', x).attr('y', d => d.y);
    }
    return selection;
  }
  onLabelHover(_ref9, label) {
    let {
      data,
      parent,
      params
    } = _ref9;
    if (this.preventMouseMove) {
      this.preventMouseMove = false;
    } else {
      const hovered = this.dataSelector(label, params);
      this.setLineOpacity({
        data,
        params
      }, 'externalHoverOpacities', hovered);
      this.setLabelOpacity({
        data,
        params
      }, 'externalHoverOpacities', hovered);
      this.setLegendOpacity({
        data,
        params
      }, 'externalHoverOpacities', hovered);
      if (this.tooltip) {
        const metric = lodash_1.default.find(data, d => this.dataSelector(d, params) === label.dataset);
        const lastDataPoint = (0, lodash_1.default)(metric.metric.data).maxBy('key');
        const circles = this.svg.selectAll(`circle.${this.cssPrefix}-circle`);
        const selector = d => d.dataset === label.dataset && d.key.getTime() === lastDataPoint.key.getTime();
        this.tooltipDatum = this.showTooltip({
          data,
          parent,
          params
        }, {
          ...label,
          ...lastDataPoint
        }, circles, selector, {
          xDiff: null,
          yDiff: null
        });
      }
    }
  }
  onLabelClick(drawParams, label) {
    const {
      params
    } = drawParams;
    if (!label) {
      this.highlighted = [];
      this.trigger('click', null);
    } else {
      const selector = this.dataSelector(label, params);
      if (selector === this.highlighted[0]) {
        this.highlighted = [];
        this.trigger('click', null);
      } else {
        this.highlighted = [selector];
        this.trigger('click', label);
      }
    }
    this.showLastPoint(this.cachedParams);
    this.hideTooltip();
    this.drawContent(drawParams);
  }
  getEntryOpacity(d, _ref10, opacityParam, hovered) {
    let {
      data,
      params
    } = _ref10;
    const opacities = LineChart.getChartStyleParam(params, opacityParam) ?? LineChart.getChartStyleParam(params, DEFAULT_HOVER_OPACITIES);
    return this.getEntryOpacityFromOpacities(d, {
      data,
      params
    }, opacities, hovered);
  }
  getEntryOpacityFromOpacities(d, _ref11, opacities, hovered) {
    let {
      data,
      params
    } = _ref11;
    const selectors = data.map(datum => this.dataSelector(datum, params));
    if (this.isHighlighted(d, params)) {
      if (!selectors.includes(this.dataSelector(d, params))) {
        return 0;
      }
      return opacities.active;
    }
    if (this.dataSelector(d, params) === hovered) {
      return opacities.hovered;
    }
    return opacities.inactive;
  }
  getLabelOpacity(d, _ref12, overrideOpacityParam, hovered) {
    let {
      data,
      params
    } = _ref12;
    if (params.labelOpacities) {
      return this.getEntryOpacityFromOpacities(d, {
        data,
        params
      }, params.labelOpacities, hovered);
    }
    return this.getEntryOpacity(d, {
      data,
      params
    }, overrideOpacityParam, hovered);
  }
  setLineOpacity(_ref13, overrideOpacityParam, hovered) {
    let {
      data,
      params
    } = _ref13;
    let combinedHighlighted = this.highlighted;
    if (Array.isArray(params.highlighted)) {
      combinedHighlighted = combinedHighlighted.concat(params.highlighted);
    }
    const drawParams = {
      data: this.highlightedData({
        data,
        params
      }, hovered),
      params
    };
    this.group.select(`.${this.cssPrefix}-chart`).selectAll(`g.${this.cssPrefix}-series`).sort((a, b) => {
      const aHl = this.isHighlighted(a, params);
      const bHl = this.isHighlighted(b, params);
      if (!aHl && !bHl) return 0;
      if (aHl && !bHl) return 1;
      if (!aHl && bHl) return -1;
      return combinedHighlighted.indexOf(this.dataSelector(b, params)) - combinedHighlighted.indexOf(this.dataSelector(a, params));
    }).style('opacity', d => this.getEntryOpacity(d, drawParams, overrideOpacityParam, hovered));
  }
  setLabelOpacity(_ref14, overrideOpacityParam, hovered) {
    let {
      data,
      params
    } = _ref14;
    // set label opacity
    this.svg.select(`g.${this.cssPrefix}-chart`).selectAll(`text.${this.cssPrefix}-label`).style('opacity', d => this.getLabelOpacity(d, {
      data,
      params
    }, overrideOpacityParam, hovered));
  }
  setLegendOpacity(_ref15, overrideOpacityParam, hovered) {
    let {
      data,
      params
    } = _ref15;
    // set legend item opacity
    this.legend.select('.legend-items').selectAll('div.chart-legend-item').style('opacity', d => this.getEntryOpacity(d, {
      data,
      params
    }, overrideOpacityParam, hovered));
  }
  // eslint-disable-next-line default-param-last
  drawLines(_ref16, xScale, yScale) {
    let {
      data,
      params
    } = _ref16;
    let shouldAreaFill = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    let maskID = arguments.length > 4 ? arguments[4] : undefined;
    let transition = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    const chartAreaGroup = this.svg.select(`g.${this.cssPrefix}-chart`);
    const line = d3.line().x(d => xScale(d.key)).y(d => yScale(d.value));
    const firstDraw = this.defs.select('mask').empty();
    if (firstDraw) {
      this.defs.append('mask');
    }
    const lineStyle = lineSelection => {
      lineSelection.style('stroke', 'currentColor').attr('d', _ref17 => {
        let {
          metric
        } = _ref17;
        const lineData = lodash_1.default.sortBy(metric.data, 'key');
        return line(lineData);
      });
    };
    const series = chartAreaGroup.selectAll(`g.${this.cssPrefix}-series`).data(data, d => this.dataSelector(d, params)).join(enter => enter.append('g').style('opacity', d => transition && !firstDraw ? 0 : this.getEntryOpacity(d, {
      data,
      params
    })), update => update).classed(`${this.cssPrefix}-series`, true).style('color', (d, i) => this.colourFunction(d, i, params));
    const lines = series.selectAll(`path.${this.cssPrefix}-line`).data(d => [d]).join(enter => enter.append('path').call(lineStyle).classed(`${this.cssPrefix}-line`, true), update => update).style('stroke-linecap', shouldAreaFill ? 'butt' : 'round').style('stroke-width', d => this.strokeWidth(d, params));
    const annotations = series.selectAll(`g.${this.cssPrefix}-annotation`).data((_ref18, metricIndex) => {
      let {
        metric = {},
        id
      } = _ref18;
      const {
        data: dataArray = []
      } = metric;
      return dataArray.map(dataPoint => {
        const annotation = (0, helpers_1.getAnnotation)(params.annotations, dataPoint.key, id, metric.xType, dataPoint.annotation);
        if (annotation) {
          return {
            ...dataPoint,
            ...annotation,
            metricIndex
          };
        }
        return null;
      }).filter(annotation => annotation !== null);
    }).join(enter => enter.append('g').call(lineStyle).classed(`${this.cssPrefix}-annotation`, true), update => update).attr('transform', _ref19 => {
      let {
        key,
        value
      } = _ref19;
      return `translate(${xScale(key)}, ${yScale(value)})`;
    });
    const bigAnnotationRadius = 10;
    const smallAnnotationRadius = 5;
    const annotationStroke = 1;
    const annotationTextPadding = 8;
    annotations.selectAll(`text.${this.cssPrefix}-annotation-text`).data(d => [d]).join('text').classed(`${this.cssPrefix}-annotation-text`, true).attr('y', function () {
      let {
        position
      } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return (position === 'below' ? 1 : -1) * (bigAnnotationRadius + annotationStroke + annotationTextPadding);
    }).style('dominant-baseline', 'middle').style('display', _ref20 => {
      let {
        showOnChart
      } = _ref20;
      return showOnChart ? null : 'none';
    }).text(_ref21 => {
      let {
        title
      } = _ref21;
      return title;
    });
    annotations.selectAll(`circle.${this.cssPrefix}-annotation-bg`).data(d => [d]).join('circle').classed(`${this.cssPrefix}-annotation-bg`, true).attr('r', bigAnnotationRadius).attr('fill', params.annotationColour || 'currentColor').attr('fill-opacity', 0.3).attr('stroke', params.annotationColour || 'currentColor').style('stroke-width', annotationStroke);
    annotations.selectAll(`circle.${this.cssPrefix}-annotation-fg`).data(d => [d]).join('circle').classed(`${this.cssPrefix}-annotation-fg`, true).attr('fill', params.annotationColour || 'currentColor').attr('r', smallAnnotationRadius);
    if (params.intro) {
      if (firstDraw) {
        chartAreaGroup.attr('mask', `url(#${maskID})`);
        const mask = this.defs.select('mask').attr('id', maskID);
        mask.append('rect').attr('x', 0).attr('y', 0).attr('width', 0).attr('height', 5000).attr('fill', 'white').transition('wipeIn').ease(d3.easeLinear).duration(INTRO_LENGTH).attrTween('width', () => t => {
          // recalculate destination width on the way there
          const dest = this.xScale.range()[1];
          return d3.interpolate(0, dest)(t);
        }).on('end', () => {
          chartAreaGroup.attr('mask', null);
          chartAreaGroup.selectAll(`text.${this.cssPrefix}-label`).transition().duration(TRANSITION_LENGTH).style('opacity', 1);
        });
        lines.call(lineStyle);
      } else if (chartAreaGroup.attr('mask')) {
        this.defs.select('mask').select('rect').attr('width', this.xScale.range()[1]);
        lines.call(lineStyle);
      } else {
        chartAreaGroup.attr('mask', null);
      }
    }
    if (transition && !firstDraw) {
      series.transition('lineStyle').duration(TRANSITION_LENGTH).style('opacity', d => this.getEntryOpacity(d, {
        data,
        params
      })).style('color', (d, i) => this.colourFunction(d, i, params));
      lines.transition('lineStyle').duration(TRANSITION_LENGTH).attrTween('d', (_ref22, i, el) => {
        let {
          metric
        } = _ref22;
        const previous = d3.select(el[i]).attr('d');
        const lineData = lodash_1.default.sortBy(metric.data, 'key');
        const current = line(lineData);
        return (0, d3_interpolate_path_1.interpolatePath)(previous, current);
      });
    } else {
      series.style('opacity', d => this.getEntryOpacity(d, {
        data,
        params
      })).style('color', (d, i) => this.colourFunction(d, i, params));
      lines.call(lineStyle);
    }
    this.drawCircles(chartAreaGroup, data, params, firstDraw, transition);
    return lines;
  }
  drawCircles(chartAreaGroup, data, params, firstDraw) {
    let transition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    const drawOrder = {};
    data.forEach((d, i) => {
      drawOrder[this.dataSelector(d, params)] = i;
    });
    const selector = d => `${this.dataSelector(d, params)}-${d.fromEnd}`;
    const circleStyle = selection => {
      selection.attr('cx', point => this.xScale(point.key)).attr('cy', point => this.yScale(point.value));
    };
    const circles = chartAreaGroup.selectAll(`circle.${this.cssPrefix}-circle`).data(this.delaunays.points, d => selector(d)).join(enter => enter.append('circle').call(circleStyle), update => update).classed(`${this.cssPrefix}-circle`, true).classed('always-visible', params.circlesVisible).attr('fill', d => this.colourFunction(d.metric, drawOrder[this.dataSelector(d.metric, params)], params)).attr('r', this.circleR);
    if (transition && !firstDraw) {
      circles.transition('circleStyle').duration(TRANSITION_LENGTH).call(circleStyle);
    } else {
      circles.call(circleStyle);
    }
    this.showLastPoint({
      params
    });
  }
  showLastPoint(drawParams) {
    const circles = this.svg.selectAll(`circle.${this.cssPrefix}-circle`);
    if (drawParams && drawParams.params.showLastPoint) {
      circles.classed('visible', d => d.fromEnd === 0);
    } else {
      circles.classed('visible', false);
    }
  }
  drawLegend(_ref23) {
    let {
      data,
      params
    } = _ref23;
    let showLegend = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    const labelMode = (0, chart_helpers_1.getLabelTextMode)(data, params);
    const showBox = LineChart.getChartStyleParam(params, 'legendShowBox');
    const sortOrder = LineChart.getChartStyleParam(params, 'legendSortOrder');
    let labels = [];
    if (showLegend) {
      labels = data.map(label => ({
        ...label,
        legendLabelText: this.getLabel(label, this.isSubchart, labelMode, params),
        dataset: this.dataSelector(label, params),
        legendShowBox: showBox ? showBox(this, label, params) : true
      }));
      if (sortOrder) {
        labels.sort(sortOrder);
      }
    }
    this.legend.style('display', showLegend ? null : 'none');
    const legendGroup = this.legend.select('.legend-items');
    const legendItems = legendGroup.selectAll('div.chart-legend-item').data(labels, d => this.dataSelector(d, params)).join(enter => {
      const group = enter.append('div').classed('chart-legend-item', true);
      group.append('div').classed('legend-box', true);
      group.append('div').classed('legend-label', true);
      group.append('div').classed('legend-item-overlay', true);
      return group;
    }, update => update);
    legendItems.on('touchstart', () => {
      // prevent mousemove on touchmove
      this.preventMouseMove = true;
    }, {
      passive: true
    }).on('mousemove', lodash_1.default.throttle((event, label) => {
      this.onLabelHover(this.cachedParams, label);
    }, constants_2.THROTTLE, {
      trailing: false
    }), {
      passive: true
    }).on('mouseout', () => {
      this.showLastPoint(this.cachedParams);
      this.hideTooltip();
      this.setLineOpacity({
        data,
        params
      });
      this.setLabelOpacity({
        data,
        params
      });
      this.setLegendOpacity({
        data,
        params
      });
      legendItems.style('opacity', d => this.getEntryOpacity(d, {
        data,
        params
      }));
    }, {
      passive: true
    }).on('click', (event, label) => {
      this.onLabelClick(this.cachedParams, label);
    }, {
      passive: true
    });
    legendItems.each((d, i) => {
      const box = legendItems.selectAll('.legend-box').nodes()[i];
      const label = legendItems.selectAll('.legend-label').nodes()[i];
      const overlay = legendItems.selectAll('.legend-item-overlay').nodes()[i];
      d3.select(box).datum(d);
      d3.select(label).datum(d);
      d3.select(overlay).datum(d);
    });
    const boxWidth = d => d.showLegendBox !== false ? params.fontSize * 0.75 : 0;
    legendItems.style('opacity', d => this.getEntryOpacity(d, {
      data: labels,
      params
    }));
    legendItems.select('div.legend-label').text(d => d.legendLabelText).style('font-size', `${params.fontSize}px`).style('color', d => this.colourFunction(d, d.sortIndex, params));
    legendItems.select('div.legend-box').style('width', d => `${boxWidth(d)}px`).style('height', `${params.fontSize * 0.75}px`).style('background-color', d => this.colourFunction(d, d.sortIndex, params));
    legendItems.select('.legend-item-overlay').style('width', (d, i, els) => {
      const label = els[i].parentElement.querySelector('.legend-label');
      const extraPadding = 10; // double the text margin
      return `${label.getBoundingClientRect().width + boxWidth(d) + extraPadding}px`;
    }).style('height', `${params.fontSize * 1.5}px`);
    legendItems.exit().remove();
    this.legend.select('.legend-title').text('Select a line');
  }
  drawEndAnnotations(_ref24, xScale, yScale) {
    let {
      data,
      params
    } = _ref24;
    const chartAreaGroup = this.svg.select(`g.${this.cssPrefix}-chart`);
    const endPoints = data.map(datum => ({
      metric: {
        id: datum.metric.id
      },
      fips: datum.fips,
      ...datum.metric.data[datum.metric.data.length - 1]
    }));
    chartAreaGroup.selectAll(`circle.${this.cssPrefix}-end-annotation-bg`).data(endPoints, d => this.dataSelector(d, params)).join('circle').classed(`${this.cssPrefix}-annotation-bg`, true).attr('cx', point => xScale(point.key)).attr('cy', point => yScale(point.value)).attr('r', 16).attr('fill', (d, i) => params.annotationColourEnd || this.colourFunction(d, i, params)).attr('fill-opacity', 0.3).attr('stroke', (d, i) => params.annotationColourEnd || this.colourFunction(d, i, params)).attr('stroke-opacity', 1).style('stroke-width', 2).style('stroke-dasharray', '3,2');
    chartAreaGroup.selectAll(`circle.${this.cssPrefix}-end-annotation-fg`).data(endPoints, d => this.dataSelector(d, params)).join('circle').classed(`${this.cssPrefix}-annotation-fg`, true).attr('cx', point => xScale(point.key)).attr('cy', point => yScale(point.value)).attr('opacity', 1).attr('fill', (d, i) => params.annotationColourEnd || this.colourFunction(d, i, params)).attr('r', 5);
  }
  createXAxis(_ref25, xScale, yScale) {
    let {
      data,
      params: {
        margins,
        xValues,
        xTickFormat,
        showXGridlines
      }
    } = _ref25;
    const keys = (0, lodash_1.default)(data).flatMap(d => d.metric.data).uniqBy(_ref26 => {
      let {
        key
      } = _ref26;
      return key.getTime();
    }).map(_ref27 => {
      let {
        key
      } = _ref27;
      return key;
    }).value();
    const firstDate = lodash_1.default.min(keys);
    const lastDate = lodash_1.default.max(keys);
    const [yStart, yEnd] = yScale.range();
    const axis = d3.axisBottom(xScale).tickSize(showXGridlines ? yStart - yEnd + margins.xAxis : 0);
    const yearDiff = d3.utcYear.count(firstDate, lastDate);
    const monthDiff = d3.utcMonth.count(firstDate, lastDate);
    if (xValues) {
      axis.tickValues(xValues);
    } else if (yearDiff > 1) {
      axis.ticks(yearDiff < this.xTicks ? d3.utcYear : this.xTicks);
      axis.tickFormat(date => d3.utcFormat('%Y')(date));
    } else if (yearDiff === 1) {
      axis.ticks(monthDiff < this.xTicks ? d3.utcMonth : this.xTicks);
      const width = Number(this.width);
      axis.tickFormat(date => {
        if (date.getUTCMonth() === 0) {
          return d3.utcFormat('%Y')(date);
        }
        return d3.utcFormat(width && width > AXIS_MONTH_LONG_BREAKPOINT ? '%B' : '%b')(date);
      });
    } else if (monthDiff > 1) {
      axis.ticks(monthDiff < this.xTicks ? d3.utcMonth : this.xTicks);
      const width = Number(this.width);
      const formatString = width && width > AXIS_MONTH_LONG_BREAKPOINT ? '%B' : '%b';
      axis.tickFormat(date => d3.utcFormat(formatString)(date));
    } else {
      axis.ticks(d3.utcWeek);
      let prevMonth = null;
      axis.tickFormat(date => {
        if (date.getUTCMonth() !== prevMonth) {
          prevMonth = date.getUTCMonth();
          return d3.utcFormat('%b %_d')(date);
        }
        return d3.utcFormat('%_d')(date);
      });
    }
    if (xTickFormat) {
      axis.tickFormat(xTickFormat);
    }
    const translate = showXGridlines ? yEnd : yStart + margins.xAxis;
    return this.svg.select('.axis.x').attr('transform', `translate(0, ${translate})`).call(axis);
  }
  createYAxis(drawParams, xScale, yScale) {
    const {
      params: {
        margins,
        yValues
      }
    } = drawParams;
    const [xStart, xEnd] = xScale.range();
    const axis = d3.axisLeft(yScale);
    if (yValues) {
      axis.tickValues(yValues).tickFormat(() => '').tickSize(xStart - xEnd - margins.xAxis);
    } else {
      axis.ticks(this.yTicks).tickFormat(t => (0, chart_helpers_1.valueFormat)(drawParams)(t, {
        ticks: yScale.ticks(this.yTicks)
      })).tickSize(xStart - xEnd);
    }
    const selection = this.svg.select('.axis.y').call(axis);
    if (yValues) {
      selection.selectAll('.tick line').attr('transform', `translate(${-margins.xAxis}, 0)`);
    }
    return selection;
  }
  drawAxes(drawParams, xScale, yScale) {
    const {
      params: {
        margins,
        hideGridlines,
        showZeroLine,
        hideAxisLabels,
        axisTextColor,
        gridColor,
        fontSize,
        yValueLabels
      }
    } = drawParams;
    const [xStart, xEnd] = xScale.range();
    const width = xEnd - xStart;
    if (width > 760) {
      this.xTicks = 8;
    } else if (width > 400) {
      this.xTicks = 4;
    } else if (width > 180) {
      this.xTicks = 3;
    } else {
      this.xTicks = 2;
    }
    const xAxis = this.createXAxis(drawParams, xScale, yScale);
    xAxis.selectAll('.tick text').style('display', hideAxisLabels === true || hideAxisLabels === 'x' ? 'none' : null).style('fill', axisTextColor).style('font-size', `${fontSize}px`);
    const yAxis = this.createYAxis(drawParams, xScale, yScale);
    yAxis.selectAll('.tick line').classed('bold', d => !yScale.domain().includes(0) && d === 0).classed('zero-line', d => d === 0).style('display', d => {
      if (showZeroLine && d === 0) {
        return null;
      }
      if (hideGridlines) {
        return 'none';
      }
      return null;
    }).style('stroke', gridColor);
    yAxis.selectAll('.tick text').style('fill', axisTextColor).style('display', hideAxisLabels === true || hideAxisLabels === 'y' ? 'none' : null).style('font-size', `${fontSize}px`);
    this.svg.select('.axis.y').attr('transform', `translate(${xStart}, 0)`).selectAll('text').attr('x', -margins.xAxis);
    // add new (possibly line-broken) axis labels
    if (yValueLabels) {
      connectedAxis_1.drawYLabelConnector.call(this, drawParams, xScale, yScale);
      connectedAxis_1.drawYValueLabels.call(this, drawParams, xScale, yScale);
    }
    return {
      xAxis,
      yAxis
    };
  }
  getHoverDatum(_ref28, delaunays, mouseX, mouseY, userHoverStyle) {
    let {
      data
    } = _ref28;
    const hoverStyle = userHoverStyle || (data.length > 1 ? '2d' : 'x');
    const delaunay = delaunays[hoverStyle];
    const hoverDatum = delaunays.points[delaunay.find(mouseX, mouseY)];
    if (!hoverDatum) {
      return null;
    }
    const xDiff = mouseX - this.xScale(hoverDatum.key);
    const yDiff = mouseY - this.yScale(hoverDatum.value);
    if (hoverStyle !== '2d' || Math.sqrt(xDiff ** 2 + yDiff ** 2) <= this.maxHoverDistance) {
      return {
        datum: hoverDatum,
        xDiff,
        yDiff
      };
    }
    return null;
  }
  showTooltip(drawParams, datum, circles, selector, diff) {
    var _datum$metric;
    const {
      data,
      parent,
      params,
      params: {
        tooltipOptions: {
          title,
          position
        }
      }
    } = drawParams;
    const datasetIndex = data.findIndex(d => this.dataSelector(d, params) === datum.dataset);
    const metric = data[datasetIndex];
    const circle = circles.filter(selector);
    if (circle.empty()) return null;
    const {
      left: circleLeft
    } = circle.node().getBoundingClientRect();
    circles.classed('visible', selector);
    const svgBox = this.svg.node().getBoundingClientRect();
    const wrapperBox = this.container.node().getBoundingClientRect();
    const r = this.circleR;
    const y = svgBox.top - wrapperBox.top + this.yScale(datum.value) + r;
    const format = (0, chart_helpers_1.tooltipFormat)({
      data: [metric],
      parent,
      params
    });
    const dataLabel = (title || metric.metric.lexiconName || metric.metric.name) + (metric.metric.geo_id && metric.metric.geo_id !== 'US' ? ` in ${metric.metric.geo_name}` : '');
    const {
      yDiff
    } = diff;
    const autoPosition = yDiff < 0 ? 'below' : 'above';
    const tooltipPosition = position || autoPosition;
    const topContent = {
      title: {
        value: datum.tooltipTitle ?? ((_datum$metric = datum.metric) === null || _datum$metric === void 0 ? void 0 : _datum$metric.tooltipTitle) ?? dataLabel
      },
      subtitle: {
        value: (0, chart_helpers_1.dateFormat)(datum.key, metric.metric.xType)
      }
    };
    const annotation = (0, helpers_1.getAnnotation)(params.annotations, datum.key, metric.id, metric.metric.xType, datum.annotation);
    const annotationRows = [];
    if (annotation && annotation.title) {
      annotationRows.push({
        type: 'annotationTitle',
        value: annotation.title
      });
    }
    if (annotation && annotation.text) {
      annotationRows.push({
        type: 'annotationText',
        value: annotation.text
      });
    }
    if (params.tooltipOptions.tooltipStyle !== 'scrub') {
      this.tooltip.draw(circleLeft + r - svgBox.left, y, topContent, [{
        type: 'value',
        value: format(datum.value)
      }, ...annotationRows], {
        primaryColour: this.colourFunction(data[datasetIndex], data[datasetIndex].sortIndex, params)
      }, 4, tooltipPosition);
    }
    return datum;
  }
  hideTooltip() {
    if (this.tooltip) {
      this.tooltip.hide();
      this.tooltipDatum = null;
    }
  }
  showScrub(left, circles, selector) {
    circles.classed('visible', selector);
    this.svg.select(`.${this.cssPrefix}-scrub`).attr('x1', left).attr('x2', left).style('opacity', 1);
  }
  isHighlighted(d, params) {
    let combinedHighlighted = this.highlighted;
    if (Array.isArray(params.highlighted)) {
      combinedHighlighted = combinedHighlighted.concat(params.highlighted);
    }
    if (combinedHighlighted.length === 0) return true;
    return combinedHighlighted.includes(this.dataSelector(d, params));
  }
  highlightedLabels(_ref29, hovered) {
    let {
      data,
      params
    } = _ref29;
    let hData = this.highlightedData({
      data,
      params
    }, hovered);
    if (hData.length > 4) {
      hData = data.filter(d => {
        if (params.chartStyle.name === 'default') return true;
        if (hovered && this.dataSelector(d, params) === hovered) return true;
        return Array.isArray(params.highlighted) && d.selector && params.highlighted.includes(d.selector);
      });
    }
    return hData;
  }
  highlightedData(_ref30, hovered) {
    let {
      data,
      params
    } = _ref30;
    return data.filter(d => {
      if (hovered && this.dataSelector(d, params) === hovered) return true;
      return this.isHighlighted(d, params);
    });
  }
  drawCanvas(dataPromises, chartOptions, visualOptions, canvas) {
    return drawCanvas_1.default.call(this, dataPromises, chartOptions, visualOptions, canvas);
  }
}
exports.default = LineChart;
LineChart.margins = {
  top: 20,
  bottom: 50,
  left: 0,
  right: 10,
  xAxis: 10,
  minRightLabel: 0,
  maxRightLabelRatio: undefined
};